<template>
  <div :class="cn(bannerVariants({ variant: type, viewport }), props.class)">
    <div class="flex items-center gap-3 transition-colors">
      <TaskStatus :status="status" />
      <span
        class="text-secondary text-style-sm font-medium"
        :class="{ 'hover:text-secondary_hover': type === 'list' }"
      >
        {{ $t(`components.filters.status.${status}`) }}
      </span>
    </div>
    <div class="flex items-center justify-end gap-0.5">
      <Badge
        :label="`${count || 0}`"
        type="light"
        color="gray-blue"
        :size="maxSmall ? 'lg' : 'sm'"
        number
      >
        <template #content>
          <LoadingSpinner v-if="loading" />
        </template>
      </Badge>
      <IconButton
        v-if="type === 'list'"
        variant="tertiary"
        type="gray"
        size="xs"
        :disabled="disabled"
        class="group-data-[state=open]:rotate-180 ease-in-out duration-300 transition-transform data-[disabled]:transition-none data-[disabled]:cursor-not-allowed"
      >
        <Icon name="chevron-down" />
      </IconButton>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { TaskStatus } from "@/SharedComponents/Tasks";
import { Badge } from "@/SharedComponents/Badges";
import { LoadingSpinner } from "@/SharedComponents/LoadingSpinner";
import { IconButton } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { bannerVariants, types, viewports } from ".";
import { cn } from "@/Utils/cn";

const { maxSmall } = useBreakpoints();

const props = defineProps({
  status: { type: String, required: true },
  count: { type: [Number, String], required: false },
  type: {
    type: String,
    validator: (val) => types.includes(val),
    default: "list",
  },
  viewport: {
    type: String,
    validator: (val) => viewports.includes(val),
    required: false,
  },
  loading: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false },
});

const viewport = computed(
  () => props.viewport || (maxSmall.value ? "mobile" : "desktop")
);
</script>
